var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "640px",
            "before-close": _vm.onDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "projectForm",
              staticClass: "add-form",
              attrs: {
                "label-width": "180px",
                model: _vm.projectForm,
                "inline-message": true,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Project Name"),
                    prop: "name",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { id: "name", placeholder: _vm.$t("Project Name") },
                    model: {
                      value: _vm.projectForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.projectForm, "name", $$v)
                      },
                      expression: "projectForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Project Description"),
                    prop: "description"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      id: "description",
                      type: "textarea",
                      placeholder: _vm.$t("Project Description")
                    },
                    model: {
                      value: _vm.projectForm.description,
                      callback: function($$v) {
                        _vm.$set(_vm.projectForm, "description", $$v)
                      },
                      expression: "projectForm.description"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Tags"), prop: "tags" } },
                [
                  _c("el-select", {
                    attrs: {
                      id: "tags",
                      placeholder: _vm.$t("Enter Tags"),
                      "allow-create": "",
                      filterable: "",
                      multiple: ""
                    },
                    model: {
                      value: _vm.projectForm.tags,
                      callback: function($$v) {
                        _vm.$set(_vm.projectForm, "tags", $$v)
                      },
                      expression: "projectForm.tags"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.onDialogClose } },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { id: "btn-submit", size: "small", type: "primary" },
                  on: { click: _vm.onAddSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("Submit")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "action-wrapper" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-select",
              {
                attrs: { size: "small", placeholder: _vm.$t("Select Tag") },
                on: { change: _vm.onFilterChange },
                model: {
                  value: _vm.filter.tag,
                  callback: function($$v) {
                    _vm.$set(_vm.filter, "tag", $$v)
                  },
                  expression: "filter.tag"
                }
              },
              [
                _c("el-option", {
                  attrs: { value: "", label: _vm.$t("All Tags") }
                }),
                _vm._l(_vm.projectTags, function(tag) {
                  return _c("el-option", {
                    key: tag,
                    attrs: { label: tag, value: tag }
                  })
                })
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-plus", type: "primary", size: "small" },
                on: { click: _vm.onAdd }
              },
              [_vm._v(" " + _vm._s(_vm.$t("Add Project")) + " ")]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "content" }, [
        _vm.projectList.length === 0
          ? _c("div", { staticClass: "empty-list" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      'You have no projects created. You can create a project by clicking the "Add" button.'
                    )
                  ) +
                  " "
              )
            ])
          : _c(
              "ul",
              { staticClass: "list" },
              _vm._l(
                _vm.projectList.filter(function(d) {
                  return d._id !== "000000000000000000000000"
                }),
                function(item) {
                  return _c(
                    "li",
                    {
                      key: item._id,
                      staticClass: "item",
                      on: {
                        click: function($event) {
                          return _vm.onView(item)
                        }
                      }
                    },
                    [
                      _c(
                        "el-card",
                        { staticClass: "item-card" },
                        [
                          !_vm.isNoProject(item)
                            ? _c("i", {
                                staticClass: "btn-edit fa fa-edit",
                                on: {
                                  click: function($event) {
                                    return _vm.onEdit(item)
                                  }
                                }
                              })
                            : _vm._e(),
                          !_vm.isNoProject(item)
                            ? _c("i", {
                                staticClass: "btn-close fa fa-trash-o",
                                on: {
                                  click: function($event) {
                                    return _vm.onRemove(item)
                                  }
                                }
                              })
                            : _vm._e(),
                          _c("el-row", [
                            _c("h4", { staticClass: "title" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ]),
                          _c("el-row", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("span", { staticClass: "spider-count" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("Spider Count")) +
                                      ": " +
                                      _vm._s(item.spiders.length) +
                                      " "
                                  )
                                ]),
                                _c("span", { staticClass: "owner" }, [
                                  _vm._v(" " + _vm._s(item.username) + " ")
                                ])
                              ]
                            )
                          ]),
                          _c("el-row", { staticClass: "description-wrapper" }, [
                            _c("div", { staticClass: "description" }, [
                              _vm._v(" " + _vm._s(item.description) + " ")
                            ])
                          ]),
                          _c("el-row", { staticClass: "tags-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "tags" },
                              _vm._l(item.tags, function(tag, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: index,
                                    staticClass: "tag",
                                    attrs: { size: "mini" }
                                  },
                                  [_vm._v(" " + _vm._s(tag) + " ")]
                                )
                              }),
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              ),
              0
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }